export default {
  slices: [
    {
      field: 'ad_categories',
      display: 'Ad Category',
      map: {
        'all_region': {
          display: 'Total',
          sortOrder: 1
        },
        'east': {
          display: 'East',
          sortOrder: 2
        },
        'west': {
          display: 'West',
          sortOrder: 3
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        'tv': {
          display: 'TV',
          sortOrder: 1
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/metadata.js